import { Pipe, PipeTransform } from '@angular/core';
import { IPenalty } from "libraries/service/resources/hotel/IResourceHotel";
import { CancellationPipesService } from "./cancellation-pipes.service";

@Pipe({
    name: 'areFreeOrFuture'
})

export class AreFreeOrFuturePipe implements PipeTransform {

    constructor(
        private readonly cancellationPipesService: CancellationPipesService
    ) {
    }

    public transform(penalty: IPenalty | IPenalty[]): any {
        return this.areFreeOrFuture(penalty);
    }

    private areFreeOrFuture(penalty: IPenalty | IPenalty[]): boolean {
        const penalties: IPenalty[] = penalty
            ? Array.isArray(penalty) ? penalty : [penalty]
            : [];

        return penalty
            && penalties.reduce(
                (isPreviousFreeOrFuture: boolean, current: IPenalty): boolean =>
                    isPreviousFreeOrFuture
                    && (
                        (current.validity && current.validity.begin && this.cancellationPipesService.isFuture(current.validity.begin))
                        || this.cancellationPipesService.isFreePenalty(current)
                    )
                ,
                true
            );
    }
}



